import axios from '@/core/http'

const fetchSpeechBackends = () => {
  return axios.get('recordings/speech-backends/').then(res => res.data)
}

export { fetchSpeechBackends }
